<template>
	<div class="grid grid-cols-1 gap-6 md:gap-8 text-sm leading-tight font-open-sans" :class="{'md:grid-cols-2': layout === 'modal'}">
		<section class="p-6">
			<div>
				<NuxtImg class="bg-white rounded-lg border max-w-[120px] p-2" :src="product?.institution.logo" />
			</div>

			<div class="mt-3 mb-4">
				<h2 class="text-xs font-semibold">{{ product?.academic_level?.name }}</h2>
				<h3 class="text-2xl font-bold">{{ product?.title }}</h3>
			</div>
			<div v-if="!hasNotSalePriceAndDiscount" class="rounded-lg bg-primary text-white font-semibold px-2 py-1 mb-4 inline-block ">
				<p class="flex">
					<Icon class="text-green-400 mt-0 text-md" icon="tabler:arrow-down" /> Bolsa de <span class="text-green-400 font-bold ml-1 mr-1">{{product?.discount}}% </span> 	pela faculdade
				</p>				
			</div>
			<ResumeProduct />

			<ReviewWithPrice
				v-if="hasSalePrice"
			></ReviewWithPrice>
			<ReviewWithoutPrice
				v-else-if="hasNotSalePrice"
			></ReviewWithoutPrice>
			<ReviewWithoutPriceScholarship
				v-else
			></ReviewWithoutPriceScholarship>
			<OfferBoxTime
				v-show="step < navigation.getIndexStep(product.product_type, OrderStepType.COMPLETED)"
			></OfferBoxTime>
		</section>
	</div>
</template>

<script lang="ts" setup>
	import ReviewWithPrice from "./partials/review-with-price.vue";
	import ReviewWithoutPrice from "./partials/review-without-price.vue";
	import ReviewWithoutPriceScholarship from "./partials/review-without-price-scholarship.vue";
	import ResumeProduct from "~/components/common/product-review/resume-product.vue";
	import { storeCoupon } from "~/store/coupon";
	import { Icon } from "@iconify/vue";
	import { storeToRefs } from "pinia";
	import { useCheckoutStore } from "~~/store/checkout";
	import { useNavigationStore } from "~~/store/navigation";
	import { OrderStepType } from "~~/enums/orderStepType";

	const checkout = useCheckoutStore();
	const { product } = storeToRefs(checkout);
	const step: any = useState("step");
	const navigation = useNavigationStore();

	const { layout, hasAction } = defineProps({
		hasAction: {
			type: Boolean,
			default: () => true
		},
		layout: {
			type: String,
			default: () => "default",
		}
	});

	const emit = defineEmits(["onClick"]);

	const couponStore = storeCoupon();
	const discount_code = ref(null);

	const hasSalePrice = computed(() => {
		return !!product.value.sale_price && !!product.value.discount;
	});

	const hasNotSalePrice = computed(() => {
		return !product.value.sale_price && !!product.value.discount;
	});

	const hasNotSalePriceAndDiscount = computed(() => {
		return !product.value.sale_price && !product.value.discount;
	});

	if (process.client) {
		const coupon = couponStore.coupon || {};
		if (!!coupon.discount && !!couponStore.code) {
			discount_code.value = await couponStore.calculate(product?.id).catch(() => null);
		}
	}
</script>